<template>
    <div>

 <app-gridview
      v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
    >
      <template v-slot:[`item.rebatelimitamount`]="{ item }">
        {{ item.rebatelimitamount ? Number(item.rebatelimitamount).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}
      </template>
    </app-gridview>

    </div>
   
</template>

<script>



import GridView from '../../../components/common/GridView'; 
import moment from 'moment';

export default {
    
    components: {
        'app-gridview': GridView
    
    },  

    data() {

         return {
            pageTitle: this.$t('setuptaxablerebategroup.taxablerebategrouplist'),

            //tab headers 
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action', sortable: false, width: '100px' },
                { text: this.$t('setuptaxablerebategroup.rebategroup'), value: 'rebategroupcode', width: '150px' },
                { text: this.$t('columns.startdate'), value: 'startdate', width: '200px' },
                { text: this.$t('columns.enddate'), value: 'enddate', width: '200px' },
                { text: this.$t('setuptaxablerebategroup.rebatelimitamount'), value: 'rebatelimitamount', width: '200px' },
                { text: this.$t('columns.currency'), value: 'currencydesc', width: '200px' },
                { text: this.$t('setuptaxablerebategroup.frequencyyears'), value: 'frequency', width: '200px' },
                { text: this.$t('setuptaxablerebategroup.control'), value: 'controldesc', width: '200px' },
                { text: this.$t('columns.remark'), value: 'remark', width: '200px' },
              
              
            ],
            dataItems: [],

            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }

    }, 

    methods: {
        
        //get all records
        getTaxableRebateGroupListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/taxablerebategroup/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    //set correct date format using moment
                    for (let i = 0; i < vm.dataItems.length; i++) {
                        if (vm.dataItems[i].startdate) {
                            vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                        }

                        if (vm.dataItems[i].enddate) {
                            vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                        }
                    }
                   
                    vm.loading = !vm.loading;
                   
                })
                .catch(function (err) {
                    vm.errMsg = err;
            });

        },

        editItemHandler(item) {
            this.$router.push({name: 'taxablerebategroupsetupedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'taxablerebategroupsetupnew'});
        }, 


    },

    mounted() {
        this.getTaxableRebateGroupListHandler();
    }
}
</script>